import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container from '../../node_modules/reactstrap/esm/Container.js';
import { primary } from '../../assets/colors.js';
import PGALogo from '../../assets/pga-logo.svg.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var HeaderContainer = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  @media (min-width: 992px) {\n    max-width: 100%;\n  }\n"])));
var HeaderFrame = styled.header(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%;\n  box-shadow: 0 5px 5px -3px grey;\n"])), function (props) {
  return props.bkgColor;
});
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 53px;\n  @media (min-width: 992px) {\n    min-height: 80px;\n  }\n"])));
var LogoFrame = styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 50px;\n  height: 38px;\n  object-fit: contain;\n  margin-left: 10px;\n\n  @media (min-width: 992px) {\n    width: 110px;\n    height: 55px;\n  }\n"])));
var Header = function Header(_ref) {
  var _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? PGALogo : _ref$logo,
    _ref$logoLink = _ref.logoLink,
    logoLink = _ref$logoLink === void 0 ? "/" : _ref$logoLink,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? primary : _ref$bgColor,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(HeaderFrame, {
    bkgColor: bgColor
  }, /*#__PURE__*/React__default.createElement(HeaderContainer, null, /*#__PURE__*/React__default.createElement(Content, null, /*#__PURE__*/React__default.createElement("a", {
    href: logoLink
  }, /*#__PURE__*/React__default.createElement(LogoFrame, {
    src: logo,
    alt: "PGA of America",
    title: "PGA of America"
  })), children)));
};
Header.propTypes = {
  logo: PropTypes.string,
  logoLink: PropTypes.string.isRequired,
  bgColor: PropTypes.string
};

export { Header as default };
